
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../bootstrap';
import '../plugins';
//import Swal from 'sweetalert2';
//import moment from 'moment';

import Vue from 'vue';

//import axios from "axios"
window.axios.defaults.headers.post['Content-Type']='application/json;charset=UTF-8';
//Vue.prototype.$http = window.axios;

window.Vue = Vue;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('example-component', require('./components/ExampleComponent').default);
Vue.component('event-form', require('./components/EventForm').default);
Vue.component('event-list', require('./components/EventList').default);
Vue.component('event-show', require('./components/EventShow').default);
Vue.component('event-scan', require('./components/EventScan').default);
Vue.component('event-reminder-form', require('./components/EventReminderForm').default);
Vue.component('contactlist-form', require('./components/ContactListForm').default);
Vue.component('contactlist-list', require('./components/ContactListList').default);
Vue.component('contactlist-show', require('./components/ContactListShow').default);
Vue.component('webcast-form', require('./components/WebcastForm').default);
Vue.component('webcast-list', require('./components/WebcastList').default);
Vue.component('webcast-show', require('./components/WebcastShow').default);
Vue.component('webcast-reminder-form', require('./components/WebcastReminderForm').default);
Vue.component('question-list', require('./components/QuestionList').default);
Vue.component('question-show', require('./components/QuestionShow').default);


//Vue.component('invitation-preview', require('./components/InvitationPreview.vue').default);

import Nl2br from 'vue-nl2br'
Vue.component('nl2br', Nl2br)

Vue.filter('hhmmss', function(value) {
    let hours =  parseInt(Math.floor(value / 3600));
    let minutes = parseInt(Math.floor((value - (hours * 3600)) / 60));
    let seconds= parseInt((value - ((hours * 3600) + (minutes * 60))) % 60);

    let dHours = (hours > 9 ? hours : '0' + hours);
    let dMins = (minutes > 9 ? minutes : '0' + minutes);
    let dSecs = (seconds > 9 ? seconds : '0' + seconds);

    return dHours + ":" + dMins + ":" + dSecs;
});


import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'

window.toastr = require('toastr')

Vue.use(VueToastr2)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#content',
});
